import config from "../config";

const dashboardService = {
  /**
   * Get all dashboard metrics for a client
   * @param {string} clientId - Client ID
   * @param {string} startDate - Start date in YYYY-MM-DD format
   * @param {string} endDate - End date in YYYY-MM-DD format
   * @returns {Promise} Dashboard metrics response
   */
  getDashboardMetrics: async (clientId, startDate = null, endDate = null) => {
    try {
      if (!clientId) {
        throw new Error("Client ID is required");
      }

      let url = `${config.API_BASE_URL}/client/dashboard/metrics?client_id=${clientId}`;

      if (startDate) {
        url += `&start_date=${startDate}`;
      }
      if (endDate) {
        url += `&end_date=${endDate}`;
      }

      console.log(`🔍 Fetching dashboard metrics from: ${url}`);

      const response = await fetch(url, {
        method: "GET",
        headers: config.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        console.log("✅ Dashboard metrics fetched successfully");
      } else {
        console.error("❌ Dashboard metrics fetch failed:", data.message);
      }

      return data;
    } catch (error) {
      console.error("❌ Error fetching dashboard metrics:", error);
      throw error;
    }
  },
};

export default dashboardService;

